module.exports = __webpack_public_path__ + "img/btn-wallet-no-open.22d1b6f9.png";